/* globals window, document */
// This module exports a promise for an object containing the additional global
// properties we must add to all slot models before passing them to the ad server.

'use strict';

const util = require('../lib/util');

function getReferrer() {
    var referrer;
    try {
        if (window.top.document.referrer) {
            referrer = window.top.document.referrer;
        }
    } catch (e) {
        referrer = document.referrer;
    }
    if (referrer) {
        return util.parseHostName(referrer);
    }
    return;
}

function getTerms() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('testads')) {
        return { terms: [...window.phxPageTarget.config.global.baseModel.terms, 'testads'] };
    }
}

module.exports = Promise.resolve({
    referrer: getReferrer(),
    ...getTerms(),
});
